// initial state
const state = () => ({
  online: [],
  chat_online: [],
  matches: [],
});

// getters
const getters = {
  getOnline: state => {
    return state.online;
  },
  getChatOnline: state => {
    return state.chat_online;
  },
  getMatches: state => {
    return state.matches;
  },
};

// actions
const actions = {
  loadOnline({ commit }) {
    return axios
      .get(zRoute('ajax.profiles.online'))
      .then(response => {
        commit('setOnline', response.data.data);
      });
  },
  loadChatOnline({ commit }) {
    return axios
      .get(zRoute('ajax.chat2.online.index'))
      .then(response => {
        commit('setChatOnline', response.data.data);
      });
  },
  loadMatches({ commit }) {
    return axios
      .get(zRoute('ajax.profiles.matches', { limit: 9 }))
      .then(response => {
        commit('setMatches', response.data.data);
      });
  },
};

// mutations
const mutations = {
  setOnline: (state, profiles) => {
    state.online = profiles;
  },
  setChatOnline: (state, profiles) => {
    state.chat_online = profiles;
  },
  setChatOnlineProfile: (state, profile) => {
    let index = state.chat_online.findIndex((x) => {
      return x.id === profile.id;
    });

    Vue.set(state.chat_online, index, profile);
  },
  setOnlineProfile: (state, profile) => {
    let index = state.online.findIndex((x) => {
      return x.id === profile.id;
    });

    Vue.set(state.online, index, profile);
  },
  setMatches: (state, randomProfiles) => {
    state.matches = randomProfiles;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
